
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { useTranslation } from "react-i18next";

interface BasicInfoFieldsProps {
  firstName: string;
  lastName: string;
  email: string;
  onFirstNameChange: (value: string) => void;
  onLastNameChange: (value: string) => void;
}

const BasicInfoFields = ({
  firstName,
  lastName,
  email,
  onFirstNameChange,
  onLastNameChange,
}: BasicInfoFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName">{t("settings.profile.firstName")}</Label>
          <Input
            id="firstName"
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">{t("settings.profile.lastName")}</Label>
          <Input
            id="lastName"
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">{t("settings.profile.email")}</Label>
        <Input
          id="email"
          type="email"
          value={email}
          disabled
        />
      </div>
    </>
  );
};

export default BasicInfoFields;
